(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leader-handbook"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var content=document.querySelector('[data-handbook-content]');
  if(!content)return;
  var children=Array.from(content.children);
  var fragment=document.createDocumentFragment();
  var chapters=[];
  var current=null;
  children.forEach(function(node){
    if(node.tagName==='H2'){
      var title=node.textContent.trim();
      var slug=title.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
      var details=document.createElement('details');
      details.className='sr-handbook__chapter';
      details.id='handbook-'+slug;
      details.setAttribute('data-handbook-search',title.toLowerCase());
      var summary=document.createElement('summary');
      var titleEl=document.createElement('span');
      titleEl.className='sr-handbook__chapter-title';
      titleEl.textContent=title;
      var toggle=document.createElement('span');
      toggle.className='sr-handbook__chapter-toggle';
      toggle.setAttribute('aria-hidden','true');
      toggle.textContent='+';
      summary.appendChild(titleEl);
      summary.appendChild(toggle);
      var body=document.createElement('div');
      body.className='sr-handbook__chapter-body';
      details.appendChild(summary);
      details.appendChild(body);
      fragment.appendChild(details);
      current={details:details,body:body,title:title,id:details.id};
      chapters.push(current);
      return;
    }
    if(current){
      current.body.appendChild(node.cloneNode(true));
      current.details.setAttribute('data-handbook-search',(current.details.getAttribute('data-handbook-search')+' '+node.textContent.toLowerCase()));
    }
  });
  content.replaceChildren(fragment);
  var nav=document.querySelector('[data-handbook-nav]');
  var mobileNav=document.querySelector('[data-handbook-mobile-nav]');
  chapters.forEach(function(chapter){
    [nav,mobileNav].forEach(function(target){
      if(!target)return;
      var a=document.createElement('a');
      a.href='#'+chapter.id;
      a.textContent=chapter.title;
      a.addEventListener('click',function(){chapter.details.open=true;});
      target.appendChild(a);
    });
  });
  var search=document.querySelector('[data-handbook-search]');
  var empty=document.querySelector('[data-handbook-empty]');
  if(search){
    search.addEventListener('input',function(){
      var q=search.value.trim().toLowerCase();
      var visible=0;
      chapters.forEach(function(chapter){
        var match=!q||(chapter.details.getAttribute('data-handbook-search')||'').includes(q);
        chapter.details.hidden=!match;
        if(match){
          visible+=1;
          if(q)chapter.details.open=true;
        }
      });
      if(empty)empty.hidden=visible!==0;
    });
  }
  if(chapters[0])chapters[0].details.open=true;
});

  } catch(e) { console.error(e); }
})();
})();
